<template>
  <a href="#" class="block block-link-shadow block-rounded block-bordered" @click.prevent="onClick">
    <div class="block-content block-content-full">
      <div class="py-5 text-center">
        <div class="mb-15">
          <i :class="[`fa fa-${icon} fa-3x text-muted`]"></i>
        </div>
        <div class="font-size-sm font-w600 text-uppercase text-muted">
          <slot />
        </div>
      </div>
    </div>
  </a>
</template>

<script>
export default {
  props: {
    icon: String
  },
  methods: {
    onClick (e) {
      this.$emit('click', e)
    }
  }
}
</script>


// WEBPACK FOOTER //
// BarcodeScannerType.vue?1a624753